// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var ConditionForm$ReactHooksTemplate = require("./ConditionForm.res.js");

function FollowUpSurveyConditions(props) {
  var removeCondition = props.removeCondition;
  var updateCondition = props.updateCondition;
  var lhsOptions = props.lhsOptions;
  var addCondition = props.addCondition;
  var followUpConditions = props.followUpConditions;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("span", {
                                        children: "Follow Up Conditions",
                                        className: "font-semibold text-gray-700 text-sm"
                                      }),
                                  className: "mb-5"
                                }),
                            Belt_List.length(followUpConditions) === 0 ? JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("button", {
                                          children: "Add condition",
                                          className: "px-4 py-1.5 text-xs font-medium text-white rounded-md focus:outline-none \n                                          focus:ring-2 focus:ring-blue-500 transition-colors duration-200 \n                                          bg-blue-600 hover:bg-blue-700",
                                          onClick: (function (param) {
                                              Curry._1(addCondition, undefined);
                                            })
                                        })
                                  }) : $$Array.of_list(Belt_List.mapWithIndex(followUpConditions, (function (index, condition) {
                                          return JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("div", {
                                                              children: JsxRuntime.jsx(ConditionForm$ReactHooksTemplate.make, {
                                                                    lhsOptions: lhsOptions,
                                                                    condition: condition,
                                                                    updateLogicCondition: (function (condition) {
                                                                        Curry._2(updateCondition, index, condition);
                                                                      })
                                                                  }),
                                                              className: "flex-1"
                                                            }),
                                                        JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("div", {
                                                                      children: JsxRuntime.jsx("img", {
                                                                            className: "h-5 w-5",
                                                                            src: Image$ReactHooksTemplate.plusCircle
                                                                          }),
                                                                      className: "cursor-pointer",
                                                                      onClick: (function (param) {
                                                                          Curry._1(addCondition, undefined);
                                                                        })
                                                                    }),
                                                                JsxRuntime.jsx("div", {
                                                                      children: JsxRuntime.jsx("img", {
                                                                            className: "h-5 w-5",
                                                                            src: Image$ReactHooksTemplate.trashGrey
                                                                          }),
                                                                      className: "cursor-pointer",
                                                                      onClick: (function (param) {
                                                                          Curry._1(removeCondition, index);
                                                                        })
                                                                    })
                                                              ],
                                                              className: "flex gap-2 items-center pt-22-px"
                                                            })
                                                      ],
                                                      className: "flex justify-between items-start w-full gap-4 mb-8"
                                                    }, String(index));
                                        })))
                          ],
                          className: "space-y-3"
                        }),
                    className: "space-y-3"
                  }),
              className: "bg-gray-50 rounded-lg p-7 border border-gray-200"
            });
}

var make = FollowUpSurveyConditions;

exports.make = make;
/* react/jsx-runtime Not a pure module */
